<template>
 <div >
  <!--  <link
      href="https://unpkg.com/@videojs/themes@1/dist/city/index.css"
      rel="stylesheet"
    />
    <video
      style="width: 100%; height: auto"
      ref="Player"
      class="video-js vjs-theme-city"
      controls
      preload="auto"
      width="640"
      height="264"
       :src="src2"
      data-setup='{"fluid": true}'
    >
      <source
        :src="src2"
        type="video/mp4"
      />

      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank"
          >supports HTML5 video</a
        >
      </p>
    </video>-->
     <video id="videoStatements" :src="src2" style="width: 100%; height: auto" controls allow="autoplay"></video>
  </div>
    
</template>
<script>
import videojs from "video.js";
import "video.js/dist/video-js.css";
export default {
  name: "VideoPlayer",
  props: {
    src2:String, 
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
      
    };
  },
  methods:{
      nextVideo(){
        alert("a");
      },
       previousVideo(){
        alert("b");
      },
  },watch: {
  src2: {
    // the callback will be called immediately after the start of the observation
    immediate: true, 
    handler (val, oldVal) {
     
    }
  }},
  mounted() {
    console.log(this.src2,"deep web");
    this.player = videojs(this.$refs.Player);
    var button = videojs.getComponent('Button');
  var closeButton = videojs.extend(button, {
    constructor: function() {
      button.apply(this, arguments);
      this.controlText("Siguiente video");
      this.addClass('vjs-icon-next-item');
       this.addClass('button-videoNext');
    },
    handleClick: this.nextVideo
  });
  var previousButton = videojs.extend(button, {
    constructor: function() {
      button.apply(this, arguments);
      this.controlText("Video anterior");
      this.addClass('vjs-icon-previous-item');
       this.addClass('button-videoPrevious');
    },
    handleClick: this.previousVideo
  });
  videojs.registerComponent('closeButton', closeButton);
  videojs.registerComponent('previousButton', previousButton);
  this.player.getChild('controlBar').addChild('previousButton', {});
  this.player.getChild('controlBar').addChild('closeButton', {});
  document.getElementsByClassName("button-videoNext")[0].style.order=2;
  document.getElementsByClassName("button-videoNext")[0].style.flex=2;
  document.getElementsByClassName("button-videoNext")[0].style.fontSize="2rem";
   document.getElementsByClassName("button-videoPrevious")[0].style.order=1;
  document.getElementsByClassName("button-videoPrevious")[0].style.flex=2;
  document.getElementsByClassName("button-videoPrevious")[0].style.fontSize="2rem";
  },
  created() {},
  beforeDestroy() {},
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/video_components/player.vue